var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1664_22190",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.84912C0 3.53541 2.68629 0.849121 6 0.849121H18C21.3137 0.849121 24 3.53541 24 6.84912V18.8491C24 22.1628 21.3137 24.8491 18 24.8491H6C2.68629 24.8491 0 22.1628 0 18.8491V6.84912Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1664_22190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7375 6.95801H17.7311L13.3761 11.9482L18.5 18.7397H14.4886L11.3444 14.6215L7.75086 18.7397H5.75536L10.4131 13.4004L5.5 6.95894H9.61357L12.4513 10.7224L15.7375 6.95801ZM15.0364 17.5437H16.1414L9.01 8.09179H7.82514L15.0364 17.5437Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.d2aab285b6bea7dafa969c9aa28d9f88.svg";
export { ForwardRef as ReactComponent };